import cn from 'classnames';
import { forwardRef } from 'react';

import type { ForwardedRef, ReactElement } from 'react';

import type { ModalFooterProps } from './modal-footer.types';

import './modal-footer.scss';

/**
 * Modal footer component is used to render the footer section of the modal dialog and it is recommended to use
 * the `ModalFooterActions` component to render the actions in the footer section.
 * All content inside the `ModalFooter` component is justified to the left. The `ModalFooterActions`
 * component is justified to the right.
 */
const ModalFooter = forwardRef((props: ModalFooterProps, forwardedRef: ForwardedRef<HTMLDivElement>): ReactElement => {
  const { children, className, ...rest } = props;

  return (
    <div {...rest} className={cn('rbui-modal__footer', className)} ref={forwardedRef}>
      {children}
    </div>
  );
});

ModalFooter.displayName = 'ModalFooter';

export default ModalFooter;
